import React from 'react'
import Error404 from '../Components/error 404/Error404'
import Footer from '../Components/Footer/Footer'
import NavBar from '../Components/NavBar/NavBar'
function Error() {
  return (
    <div>
            <NavBar/>
            <Error404/>
      <Footer/>
    </div>
  )
}

export default Error
